import { render, staticRenderFns } from "./CompanyDataUpdateApplications.vue?vue&type=template&id=0bb68881&scoped=true&"
import script from "./CompanyDataUpdateApplications.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateApplications.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateApplications.vue?vue&type=style&index=0&id=0bb68881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb68881",
  null
  
)

export default component.exports